module.exports = __webpack_public_path__ + "img/pet-art-full.ce64a2b3.webp";